import React from 'react';
import ReactDOM from 'react-dom';
import Raven from 'raven-js';
import $ from 'jquery';

import CreateGameRoot from './apps/create_game/components/CreateGameRoot';
import ResultEntryRoot from './apps/result_entry/components/ResultEntryRoot';
import configureStore from "./utils/configureStore";

import Timer from './components/Timer';

import createGameReducer from './apps/create_game/reducers';
import resultEntryReducer from './apps/result_entry/reducers';
import {fetchPlayers, fetchCourses} from "./apps/create_game/thunkActions";
import {fetchGameInfo} from "./apps/result_entry/thunkActions";

window.jQuery = window.$ = $; // eslint-disable-line no-multi-assign
require('bootstrap');

// Install Raven in production envs
if (process.env.NODE_ENV === 'production') {
    Raven.config(DJ_CONST.RAVEN_PUBLIC_DSN).install(); // eslint-disable-line
    // handle rejected promises
    window.addEventListener('unhandledrejection', (evt) => {
        Raven.captureException(evt.reason);
    });
    // If we have authenticated user, pass its data on to Raven
    if (DJ_CONST.user) {
        Raven.setUserContext({
            id: DJ_CONST.user.id,
            email: DJ_CONST.user.email,
            name: DJ_CONST.user.name,
        });
    }
}

function gameTimes() {
    const times = document.getElementsByClassName('game-time');
    if (times.length === 0) {
        return;
    }

    Array.prototype.forEach.call(times, (time) => {
        const start = time.dataset.start;
        ReactDOM.render(<Timer time={start} />, time);
    });
}

function init() {
    gameTimes();
}

function initCreateGame() {
    const store = configureStore(createGameReducer);

    let getLocation = false;
    setTimeout(() => {
        if (!getLocation) {
            store.dispatch(fetchCourses({}));
        }
    }, 6000);

    navigator.geolocation.getCurrentPosition((location) => {
        getLocation = true;
        store.dispatch(fetchCourses({
            lat: location.coords.latitude,
            lng: location.coords.longitude,
        }));
    }, () => {
        getLocation = true;
        store.dispatch(fetchCourses({}));
    }, {maximumAge: 300000});

    store.dispatch(fetchPlayers(''));

    ReactDOM.render(
        <CreateGameRoot store={store} />,
        document.getElementById('discore-root'),
    );
}

function initResultEntry(gameId) {
    const store = configureStore(resultEntryReducer);

    store.dispatch(fetchGameInfo(gameId));
    ReactDOM.render(
        <ResultEntryRoot store={store} />,
        document.getElementById('result-entry-root'),
    );
}

function initPlayerStatsChart(containerId, data) {
    /* global google */
    // Load the Visualization API and the corechart package.
    google.charts.load('current', {packages: ['corechart']});

    function drawChart() {
        const visualizedData = new google.visualization.DataTable();
        visualizedData.addColumn('string', 'Label');
        visualizedData.addColumn('number', 'Number');
        visualizedData.addRows(data);

        const options = {
            fontName: 'Lato',
            titlePosition: 'none',
            pieSliceText: 'value',
            legend: {
                position: 'right',
            },
            pieHole: 0.4,
            chartArea: {
                top: 10,
                bottom: 10,
                height: 350,
            },
            slices: {
                0: {color: '#ffe500'},
                1: {color: '#80df9b'},
                2: {color: '#1EDFB3'},
                3: {color: '#57B5DF'},
                4: {color: '#FFC884'},
                5: {color: '#FF6300'},
                6: {color: 'red'},
            },
        };

        const chart = new google.visualization.PieChart(document.getElementById(containerId));
        chart.draw(visualizedData, options);
    }

    // Set a callback to run when the Google Visualization API is loaded.
    google.charts.setOnLoadCallback(drawChart);
}

function initResultsChart(containerId, data, teams, basketsCount, graphAmplitude) {
    /* global google */
    // Load the Visualization API and the corechart package.
    google.charts.load('current', {packages: ['corechart']});

    function drawChart() {
        const visualizedData = new google.visualization.DataTable();

        visualizedData.addColumn('number', 'Tee');

        teams.forEach(teamName => visualizedData.addColumn('number', teamName));
        visualizedData.addRows(data);

        const options = {
            fontName: 'Lato',
            legend: {
                position: 'top',
            },
            pointSize: 4,
            hAxis: {
                baselineColor: 'transparent',
                gridlines: {
                    color: '#eee',
                    count: basketsCount,
                },
                textStyle: {
                    color: '#7D858E',
                },
                format: "#",
            },
            vAxis: {
                baselineColor: 'transparent',
                gridlines: {
                    color: '#eee',
                    count: graphAmplitude,
                },
                textStyle: {
                    color: '#7D858E',
                },
                format: '+#;-#',
            },
            chartArea: {
                width: '80%',
            },
        };

        const chart = new google.visualization.LineChart(document.getElementById(containerId));
        chart.draw(visualizedData, options);
    }

    // Set a callback to run when the Google Visualization API is loaded.
    google.charts.setOnLoadCallback(drawChart);
}

function replaceFormPrefix($form, prefix, oldValue, newValue) {
    // Increase form IDs in the template
    $form.find(':input').each(function () {
        const elem = $(this);
        if (elem.attr('name') === "prefix") {
            elem.val(elem.val().replace(oldValue, newValue));
            return;
        }
        if (!elem.attr('name')) {
            return;
        }
        const name = elem.attr('name').replace(oldValue, newValue);
        const id = elem.attr('id').replace(oldValue, newValue);
        elem.attr({name, id});
    });

    $form.find(`label[for^="id_${prefix}${oldValue}"]`).each(function () {
        const newFor = $(this).attr('for').replace(oldValue, newValue);
        $(this).attr('for', newFor);
    });

    $form.find(`div[id^="div_id_${prefix}${oldValue}"]`).each(function () {
        const newID = $(this).attr('id').replace(oldValue, newValue);
        $(this).attr('id', newID);
    });

    $form.find(`p[id^="hint_id_${prefix}${oldValue}"]`).each(function () {
        const newID = $(this).attr('id').replace(oldValue, newValue);
        $(this).attr('id', newID);
    });

    return $form;
}

function cloneForm($form) {
    const $newForm = $form.clone();
    $newForm.find('.form-group.has-error .help-block').remove();
    $newForm.find('.form-group.has-error').removeClass('has-error');
    $newForm.find('.textinput, .emailinput').val('');
    $newForm.find('.checkboxinput, .checkbox').prop('checked', false);
    $newForm.find('select').each(function () {
        $(this).val($(this).find('option:first-child').attr('value'));
    });

    $newForm.removeClass('hide');

    return $newForm;
}

function initFormset(cloneableElementSelector, $clickListener, modelName) {
    /*
        Initializes django formset.
        Arguments:
          - cloneableElementSelector: HTML selector to be duplicated (e.g. last row of the data table)
          - $clickListener: the button that should create a new form
          - modelName: (usually) plural form of the model name, that django uses for inputs/classes, used in management
          form ($('#id_' + modelName +'-TOTAL_FORMS'))
     */
    const $cloneableElement = $(cloneableElementSelector);
    $clickListener.data('form-clone', cloneForm($cloneableElement));

    let initialTotal = null;

    $clickListener.click(function (e) {
        e.preventDefault();
        const total = parseInt($(`#id_${modelName}-TOTAL_FORMS`).val(), 10);
        let $newForm = $(this).data('form-clone').clone();
        if (initialTotal == null) {
            initialTotal = total;
        }
        $newForm = replaceFormPrefix($newForm, modelName, `-${initialTotal - 1}-`, `-${total}-`);
        $(cloneableElementSelector).after($newForm);
        $(`#id_${modelName}-TOTAL_FORMS`).val(total + 1);
        $(`#id_baskets-${total}-number`).val(total + 1);
    });
}

function updateCoordinatesFromMarker(marker) {
    const lat = parseFloat(marker.getPosition().lat());
    const lng = parseFloat(marker.getPosition().lng());
    $('#div_id_longitude input').val(lng.toFixed(6));
    $('#div_id_latitude input').val(lat.toFixed(6));
}

function initMapView(selector, lat = 58.708611, lng = 25.897778) {
    // We show the initial location in the center of continental Estonia (Adavere)
    const position = new google.maps.LatLng(lat, lng);
    const mapOptions = {
        center: position,
        zoom: 12,
    };

    const map = new google.maps.Map(document.getElementById(selector), mapOptions);

    // Place a draggable marker on the map
    const marker = new google.maps.Marker({
        position,
        map,
        draggable: true,
        gestureHandling: "cooperative",
    });
    marker.setMap(map);
    updateCoordinatesFromMarker(marker);
    google.maps.event.addListener(marker, 'dragend', () => {
        updateCoordinatesFromMarker(marker);
    });
}

function updateCoordinatesFields(address) {
    /*
        Updates coordinates fields based on given address
          address - string represantation of the address
     */
    const geocoder = new google.maps.Geocoder();
    let lng = 0;
    let lat = 0;
    geocoder.geocode({address}, (results) => {
        if (results.length) {
            lat = results[0].geometry.location.lat();
            lng = results[0].geometry.location.lng();
            $('#div_id_longitude input').val(lng.toFixed(6));
            $('#div_id_latitude input').val(lat.toFixed(6));
            initMapView('map-canvas', lat, lng);
        }
    });
}

function initCourseForm() {
    // Initialize baskets formset
    initFormset('#baskets tbody .basket:last-child', $('#add-basket'), 'baskets');

    // Update coordinates fields when user changes any address field
    $('#div_id_country input, #div_id_county input, #div_id_city input').change(() => {
        const country = $('#div_id_country input').val();
        const county = $('#div_id_county input').val();
        const city = $('#div_id_city input').val();
        const address = `${country} ${county} ${city}`;
        updateCoordinatesFields(address);
    });
}

export {init, initCreateGame, initResultEntry, initPlayerStatsChart, initResultsChart, initCourseForm, initMapView};




// WEBPACK FOOTER //
// ./src/main.js